export default __webpack_public_path__ + "static/media/capsule-paid.290ed23f.png";